/*
 * @Descripttion: 
 * @version: 
 * @Author: jinfjk
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbqin
 * @LastEditTime: 2021-09-01 11:26:46
 */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';

import { createByModuleType, deleteKeyByModuleId } from './createKeyMap';
import { stopFormHotKeyChange } from './config/stopHotKeyChange';
import { keyDownOfShiftUp } from './handleKeyDown';
import { keyMap } from './config/tableKeyboardMap';
import { config as CONFIG, PubSub } from '@platform/api';
import './hotKey.less';

function FormWithKeyboardChange(WrappedComponent) {
    return class WithHotKey extends Component {
        constructor(props) {
            super(props);
            this.formStatusChanged = this.formStatusChanged.bind(this);
            this.status = null;
        }

        componentDidMount() {
            //监听业务组手动执行的聚焦事件
            this.autoFocusToken = PubSub.subscribe('autoFocus-IoC', () => {
                //form的状态， 浏览态， add, edit
                let status = this.props.store.getStatus();

                //如果是业务组控制执行 autoFocusDeferred 设为false；
                let autoFocusDeferred = false;

                if (stopFormHotKeyChange({ props: this.props, autoFocusDeferred, status }) || status === 'browse') return;
                createByModuleType['form'](this.props, true);
            });
        }

        componentWillUnmount() {
            // 部分情况下KeyByModuleId 没有清除  导致创建不能直接聚焦
            deleteKeyByModuleId(this.props.moduleId || this.props.name);
            this.autoFocusToken && PubSub.unsubscribe(this.autoFocusToken);
            this.status = null;
        }

        formStatusChanged(props, status) {
            // 由于更新逻辑写在shouldUpdate中 避免重复更新，做下判断
            if (this.status === status) {
                return;
            }
            if (status === 'browse') {
                deleteKeyByModuleId(props.moduleId || props.name);
            } else {
                this.judgeCreateKeyMap(props, status);
            }
            this.status = status;
        }

        judgeCreateKeyMap(props, status) {
            let { autoFocusDeferred = false } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
            if (stopFormHotKeyChange({ props, autoFocusDeferred, status })) return;
            createByModuleType['form'](props);
        }

        render() {
            const moduleId = this.props.name;
            return (
                <HotKeys
                    keyMap={keyMap}
                    handlers={{
                        shiftUp: keyDownOfShiftUp.bind(this, moduleId),
                        shiftDown: keyDownOfShiftUp.bind(this, moduleId),
                    }}
                    id={`${CONFIG.hotKeyModuleIdPrefix}-${moduleId}`}
                    className="form-hotkey-wrapper"
                >
                    <WrappedComponent
                        {...this.props}
                        formStatusChanged={this.formStatusChanged}
                    />
                </HotKeys>
            );
        }
    };
}

export default FormWithKeyboardChange;